import { userWishlistFun, userWishlistIdFun } from '../../../api/userAPI';

export const fetchWishlistData = async (typeSel, setUserWishlist) => {
    const type = typeSel;
    try {
        const res = await userWishlistIdFun(type);
        if (res.data.length > 0) {
            // const userWishlistIds = new Set(res.data[0][typeSel].map((item) => item));
            setUserWishlist(res.data[0][type]);
        }
    } catch (error) {
        console.log(error);
        setUserWishlist([]);
    }
};

export const fetchWishlistWithLimit = async (typeSel, limit, offset, setUserWishlist) => {
    console.log(limit, offset);
    try {
        const res = await userWishlistFun(typeSel, limit, offset);
        console.log(res.data[0][typeSel]);
        if (res.data.length > 0) {
            // const userWishlistIds = new Set(res.data[0][typeSel].map((item) => item));
            setUserWishlist(res.data[0][typeSel]);
        }
    } catch (error) {
        console.log(error);
        setUserWishlist([]);
    }
};

export const getUserWishlistIds = (userWishlist, typeSel) => {
    if (userWishlist?.length > 0 && userWishlist[0][typeSel]) {
        // return new Set(userWishlist[0][typeSel].map((item) => item));
        return userWishlist[0][typeSel];
    }
    return [];
};
